import * as React from "react";
import { Button } from "semantic-ui-react";

interface Props {
    customerId: string;
    employeeRecordId: string;
    ohCaseId: string;
    taskId: string;
}

// Used on both 1) ReferralClinicalNotesSections.tsx and 2) ReferralReport.tsx components
// For 1) and 2) taskId is an id of task of different types, but backend handles it
export const PreviewReferralReportButton: React.FunctionComponent<Props> = (props: Props) => {
    if (!props.customerId || !props.employeeRecordId || !props.ohCaseId || !props.taskId) {
        return null;
    }
    return (
        <a
            href={`/customers/${props.customerId}/employeeRecords/${props.employeeRecordId}/ohCases/${props.ohCaseId}/${props.taskId}/previewReport`}
            target="_blank"
            rel="noopener noreferrer"
        >
            <Button type="button" content="Preview Report" />
        </a>
    );
};
